import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=none, obj=logged in

  useEffect(() => {
    api.get("/auth/me").then((r) => { setAdmin(r.data); localStorage.setItem("bt_no_track", "1"); }).catch(() => setAdmin(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAdmin(data);
    localStorage.setItem("bt_no_track", "1");
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
}
